module.exports = __webpack_public_path__ + "static/media/twitter.ee5f1157.svg";